module.exports = __webpack_public_path__ + "img/Valencia.09915721.png";